import { useQuery } from 'react-query';
import {
  fetchExaminationDiagnosis,
  fetchExaminationDiagnosisForVisits,
} from '@higo/api/lib/services';
import { useExaminationApiContext } from '@higo/common/src/features/ExaminationPage/providers';
import { ExaminationQueryKey } from '@higo/common/src/features/ExaminationPage/ExaminationQueryKey';

export const useExaminationDiagnosisQuery = (
  examinationId: number,
  enabled: boolean = true,
  isVisitDiagnosis: boolean,
) => {
  const axios = useExaminationApiContext();

  return useQuery(
    [ExaminationQueryKey.ExaminationDiagnosis, examinationId],
    () =>
      !isVisitDiagnosis
        ? fetchExaminationDiagnosis(axios)(examinationId)
        : fetchExaminationDiagnosisForVisits(axios)(examinationId),
    {
      enabled: enabled,
      refetchOnMount: true,
    },
  );
};
